import React from 'react';

import { observer } from 'mobx-react';
import { Surface } from '@infoods/lifebase-ui';

import classes from './ClientsDemographicWidget.module.scss';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { ClientsInfoItem } from '../../../components/ClientsInfoItem/ClientsInfoItem';
import { DemographicsGraph } from './DemographicsGraph/DemographicsGraph';
import { useClientDemographicData } from './hooks/useClientDemographicData';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';

const ClientsDemographicWidget = observer(() => {
  const { dateRangePreset, solutionTypeFilter } = entityDashboardFilterStore;
  const { clientDemographicData } = useClientDemographicData({
    dateRangePreset,
    solutionTypeFilter,
  });

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Active Client Demographics"
        tooltipContent={
          <>
            Gender + age breakdown
            <br />
            Active customers only
          </>
        }
      />
      {clientDemographicData && (
        <>
          <div className={classes.metricsContainer}>
            <ClientsInfoItem
              title="Female Customers"
              value={clientDemographicData.femaleCustomers.value}
              diffPercent={clientDemographicData.femaleCustomers.diffPercent}
              hideComparisonPeriod
              indicatorColor="violet-100"
            />
            <ClientsInfoItem
              title="Male Customers"
              value={clientDemographicData.maleCustomers.value}
              diffPercent={clientDemographicData.maleCustomers.diffPercent}
              hideComparisonPeriod
              indicatorColor="info-200"
            />
          </div>
          <DemographicsGraph graphData={clientDemographicData.graphData} />
        </>
      )}
    </Surface>
  );
});

export { ClientsDemographicWidget };
